// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { IClaimActorAggregatorDto } from './IClaimActorAggregatorDto';
import {
    IClaimActorAggregatorDtoFromJSON,
    IClaimActorAggregatorDtoFromJSONTyped,
    IClaimActorAggregatorDtoToJSON,
    IClaimActorAggregatorDtoToJSONTyped,
} from './IClaimActorAggregatorDto';

/**
 * 
 * @export
 * @interface IClaimApprovalStatusAggregatorDto
 */
export interface IClaimApprovalStatusAggregatorDto {
    /**
     * 
     * @type {number}
     * @memberof IClaimApprovalStatusAggregatorDto
     */
    id?: number;
    /**
     * 
     * @type {number}
     * @memberof IClaimApprovalStatusAggregatorDto
     */
    claim_id?: number;
    /**
     * 
     * @type {string}
     * @memberof IClaimApprovalStatusAggregatorDto
     */
    claim_approval_status_type?: IClaimApprovalStatusAggregatorDtoClaimApprovalStatusTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof IClaimApprovalStatusAggregatorDto
     */
    claim_approval_status_code?: IClaimApprovalStatusAggregatorDtoClaimApprovalStatusCodeEnum;
    /**
     * 
     * @type {Array<string>}
     * @memberof IClaimApprovalStatusAggregatorDto
     */
    claim_approval_status_codes?: Array<IClaimApprovalStatusAggregatorDtoClaimApprovalStatusCodesEnum>;
    /**
     * 
     * @type {string}
     * @memberof IClaimApprovalStatusAggregatorDto
     */
    custom_denial_reason?: string;
    /**
     * 
     * @type {Date}
     * @memberof IClaimApprovalStatusAggregatorDto
     */
    valid_from?: Date;
    /**
     * 
     * @type {Date}
     * @memberof IClaimApprovalStatusAggregatorDto
     */
    valid_to?: Date;
    /**
     * 
     * @type {IClaimActorAggregatorDto}
     * @memberof IClaimApprovalStatusAggregatorDto
     */
    claim_actor?: IClaimActorAggregatorDto;
    /**
     * 
     * @type {number}
     * @memberof IClaimApprovalStatusAggregatorDto
     */
    approved_amount?: number;
    /**
     * 
     * @type {boolean}
     * @memberof IClaimApprovalStatusAggregatorDto
     */
    initially_processed_incorrectly?: boolean;
}

/**
* @export
* @enum {string}
*/
export enum IClaimApprovalStatusAggregatorDtoClaimApprovalStatusTypeEnum {
    PENDING_REVIEW = 'PENDING_REVIEW',
    UNDER_REVIEW = 'UNDER_REVIEW',
    DOCS_NEEDED = 'DOCS_NEEDED',
    INCOMPLETE = 'INCOMPLETE',
    PARTIALLY_APPROVED = 'PARTIALLY_APPROVED',
    APPROVED = 'APPROVED',
    DENIED = 'DENIED',
    CANCELLED = 'CANCELLED',
    VOIDED = 'VOIDED'
}
/**
* @export
* @enum {string}
*/
export enum IClaimApprovalStatusAggregatorDtoClaimApprovalStatusCodeEnum {
    EXPENSE_NOT_ELIGIBLE_PER_IRS_RULES = 'EXPENSE_NOT_ELIGIBLE_PER_IRS_RULES',
    EXPENSE_NOT_ELIGIBLE_PER_PLAN_RULES = 'EXPENSE_NOT_ELIGIBLE_PER_PLAN_RULES',
    SERVICE_DATE_OUTSIDE_OF_COVERAGE_PERIOD = 'SERVICE_DATE_OUTSIDE_OF_COVERAGE_PERIOD',
    CLAIM_RECEIVED_AFTER_RUNOUT_DATE = 'CLAIM_RECEIVED_AFTER_RUNOUT_DATE',
    CLAIM_SUBMITTED_AFTER_GRACE_PERIOD = 'CLAIM_SUBMITTED_AFTER_GRACE_PERIOD',
    DUPLICATE_CLAIM = 'DUPLICATE_CLAIM',
    PROOF_OF_EXPENSE_NEEDED = 'PROOF_OF_EXPENSE_NEEDED',
    LETTER_OF_MEDICAL_NECESSITY_REQUIRED = 'LETTER_OF_MEDICAL_NECESSITY_REQUIRED',
    DETAILED_RECEIPT_REQUIRED = 'DETAILED_RECEIPT_REQUIRED',
    ADDITIONAL_DOCUMENTATION_NEEDED_TO_SUBSTANTIATE_TRANSACTION = 'ADDITIONAL_DOCUMENTATION_NEEDED_TO_SUBSTANTIATE_TRANSACTION',
    ADDITIONAL_COMMENTS = 'ADDITIONAL_COMMENTS',
    CARD_SWIPE_DECLINED_BY_CARD_PROCESSOR = 'CARD_SWIPE_DECLINED_BY_CARD_PROCESSOR',
    AUTOMATICALLY_APPROVED_COPAY_MATCH = 'AUTOMATICALLY_APPROVED_COPAY_MATCH',
    AUTOMATICALLY_APPROVED_NO_RECEIPT_REQUIRED = 'AUTOMATICALLY_APPROVED_NO_RECEIPT_REQUIRED',
    AUTOMATICALLY_APPROVED_BY_CARD_PROCESSOR_IIAS = 'AUTOMATICALLY_APPROVED_BY_CARD_PROCESSOR_IIAS',
    AUTOMATICALLY_APPROVED_BY_CARD_PROCESSOR_COPAY_MATCH = 'AUTOMATICALLY_APPROVED_BY_CARD_PROCESSOR_COPAY_MATCH',
    AUTOMATICALLY_APPROVED_BY_CARD_PROCESSOR_TRUSTED_MERCHANT = 'AUTOMATICALLY_APPROVED_BY_CARD_PROCESSOR_TRUSTED_MERCHANT',
    CLAIM_COULD_NOT_BE_AUTO_SUBSTANTIATED_BY_CARD_PROCESSOR = 'CLAIM_COULD_NOT_BE_AUTO_SUBSTANTIATED_BY_CARD_PROCESSOR',
    AUTOMATICALLY_APPROVED_BY_CARD_PROCESSOR_CARRIER_CLAIM = 'AUTOMATICALLY_APPROVED_BY_CARD_PROCESSOR_CARRIER_CLAIM',
    AUTOMATICALLY_APPROVED_BY_CARD_PROCESSOR_RECURRING_CLAIM = 'AUTOMATICALLY_APPROVED_BY_CARD_PROCESSOR_RECURRING_CLAIM',
    AUTOMATICALLY_APPROVED_BY_CARD_PROCESSOR_SUBSTANTIATION_NOT_REQUIRED = 'AUTOMATICALLY_APPROVED_BY_CARD_PROCESSOR_SUBSTANTIATION_NOT_REQUIRED',
    AUTOMATICALLY_APPROVED_CARRIER_CLAIM = 'AUTOMATICALLY_APPROVED_CARRIER_CLAIM',
    AUTOMATICALLY_APPROVED_AI_RECEIPT_APPROVED = 'AUTOMATICALLY_APPROVED_AI_RECEIPT_APPROVED',
    AUTOMATICALLY_APPROVED_CONTRIBUTION_RETURN_ACCOUNT_CLOSURE = 'AUTOMATICALLY_APPROVED_CONTRIBUTION_RETURN_ACCOUNT_CLOSURE',
    AUTOMATICALLY_APPROVED_BALANCE_RETURN_ACCOUNT_CLOSURE = 'AUTOMATICALLY_APPROVED_BALANCE_RETURN_ACCOUNT_CLOSURE',
    CANNOT_BE_REIMBURSED_FOR_FUTURE_DOS = 'CANNOT_BE_REIMBURSED_FOR_FUTURE_DOS',
    CLAIM_SUBMITTED_AFTER_DEADLINE = 'CLAIM_SUBMITTED_AFTER_DEADLINE',
    MEDICAL_EXPENSE_NOT_ELIGIBLE = 'MEDICAL_EXPENSE_NOT_ELIGIBLE',
    ADDITIONAL_INFO_NEEDED_FOR_PRIOR_BALANCE_DUE = 'ADDITIONAL_INFO_NEEDED_FOR_PRIOR_BALANCE_DUE',
    AMOUNT_NEEDED = 'AMOUNT_NEEDED',
    DATE_OF_SERVICE_NEEDED = 'DATE_OF_SERVICE_NEEDED',
    DATE_RANGE_OF_CARE_NEEDED = 'DATE_RANGE_OF_CARE_NEEDED',
    DOCUMENT_NEEDS_TO_BE_ENGLISH_AND_USD = 'DOCUMENT_NEEDS_TO_BE_ENGLISH_AND_USD',
    DOCUMENT_NOT_READABLE = 'DOCUMENT_NOT_READABLE',
    HANDWRITTEN_RECEIPT_NOT_SUFFICIENT = 'HANDWRITTEN_RECEIPT_NOT_SUFFICIENT',
    MERCHANT_NEEDED = 'MERCHANT_NEEDED',
    SERVICE_DESCRIPTION_NEEDED = 'SERVICE_DESCRIPTION_NEEDED',
    SERVICE_FOR_NEEDED = 'SERVICE_FOR_NEEDED',
    AUTOMATICALLY_APPROVED_RECURRING_CARD_SWIPE = 'AUTOMATICALLY_APPROVED_RECURRING_CARD_SWIPE',
    CUSTOM = 'CUSTOM',
    AUTOMATICALLY_APPROVED_BY_SIGIS = 'AUTOMATICALLY_APPROVED_BY_SIGIS',
    AUTOMATICALLY_APPROVED_EXCESS_CONTRIBUTION_REQUEST = 'AUTOMATICALLY_APPROVED_EXCESS_CONTRIBUTION_REQUEST',
    APPEAL_NOTE = 'APPEAL_NOTE'
}
/**
* @export
* @enum {string}
*/
export enum IClaimApprovalStatusAggregatorDtoClaimApprovalStatusCodesEnum {
    EXPENSE_NOT_ELIGIBLE_PER_IRS_RULES = 'EXPENSE_NOT_ELIGIBLE_PER_IRS_RULES',
    EXPENSE_NOT_ELIGIBLE_PER_PLAN_RULES = 'EXPENSE_NOT_ELIGIBLE_PER_PLAN_RULES',
    SERVICE_DATE_OUTSIDE_OF_COVERAGE_PERIOD = 'SERVICE_DATE_OUTSIDE_OF_COVERAGE_PERIOD',
    CLAIM_RECEIVED_AFTER_RUNOUT_DATE = 'CLAIM_RECEIVED_AFTER_RUNOUT_DATE',
    CLAIM_SUBMITTED_AFTER_GRACE_PERIOD = 'CLAIM_SUBMITTED_AFTER_GRACE_PERIOD',
    DUPLICATE_CLAIM = 'DUPLICATE_CLAIM',
    PROOF_OF_EXPENSE_NEEDED = 'PROOF_OF_EXPENSE_NEEDED',
    LETTER_OF_MEDICAL_NECESSITY_REQUIRED = 'LETTER_OF_MEDICAL_NECESSITY_REQUIRED',
    DETAILED_RECEIPT_REQUIRED = 'DETAILED_RECEIPT_REQUIRED',
    ADDITIONAL_DOCUMENTATION_NEEDED_TO_SUBSTANTIATE_TRANSACTION = 'ADDITIONAL_DOCUMENTATION_NEEDED_TO_SUBSTANTIATE_TRANSACTION',
    ADDITIONAL_COMMENTS = 'ADDITIONAL_COMMENTS',
    CARD_SWIPE_DECLINED_BY_CARD_PROCESSOR = 'CARD_SWIPE_DECLINED_BY_CARD_PROCESSOR',
    AUTOMATICALLY_APPROVED_COPAY_MATCH = 'AUTOMATICALLY_APPROVED_COPAY_MATCH',
    AUTOMATICALLY_APPROVED_NO_RECEIPT_REQUIRED = 'AUTOMATICALLY_APPROVED_NO_RECEIPT_REQUIRED',
    AUTOMATICALLY_APPROVED_BY_CARD_PROCESSOR_IIAS = 'AUTOMATICALLY_APPROVED_BY_CARD_PROCESSOR_IIAS',
    AUTOMATICALLY_APPROVED_BY_CARD_PROCESSOR_COPAY_MATCH = 'AUTOMATICALLY_APPROVED_BY_CARD_PROCESSOR_COPAY_MATCH',
    AUTOMATICALLY_APPROVED_BY_CARD_PROCESSOR_TRUSTED_MERCHANT = 'AUTOMATICALLY_APPROVED_BY_CARD_PROCESSOR_TRUSTED_MERCHANT',
    CLAIM_COULD_NOT_BE_AUTO_SUBSTANTIATED_BY_CARD_PROCESSOR = 'CLAIM_COULD_NOT_BE_AUTO_SUBSTANTIATED_BY_CARD_PROCESSOR',
    AUTOMATICALLY_APPROVED_BY_CARD_PROCESSOR_CARRIER_CLAIM = 'AUTOMATICALLY_APPROVED_BY_CARD_PROCESSOR_CARRIER_CLAIM',
    AUTOMATICALLY_APPROVED_BY_CARD_PROCESSOR_RECURRING_CLAIM = 'AUTOMATICALLY_APPROVED_BY_CARD_PROCESSOR_RECURRING_CLAIM',
    AUTOMATICALLY_APPROVED_BY_CARD_PROCESSOR_SUBSTANTIATION_NOT_REQUIRED = 'AUTOMATICALLY_APPROVED_BY_CARD_PROCESSOR_SUBSTANTIATION_NOT_REQUIRED',
    AUTOMATICALLY_APPROVED_CARRIER_CLAIM = 'AUTOMATICALLY_APPROVED_CARRIER_CLAIM',
    AUTOMATICALLY_APPROVED_AI_RECEIPT_APPROVED = 'AUTOMATICALLY_APPROVED_AI_RECEIPT_APPROVED',
    AUTOMATICALLY_APPROVED_CONTRIBUTION_RETURN_ACCOUNT_CLOSURE = 'AUTOMATICALLY_APPROVED_CONTRIBUTION_RETURN_ACCOUNT_CLOSURE',
    AUTOMATICALLY_APPROVED_BALANCE_RETURN_ACCOUNT_CLOSURE = 'AUTOMATICALLY_APPROVED_BALANCE_RETURN_ACCOUNT_CLOSURE',
    CANNOT_BE_REIMBURSED_FOR_FUTURE_DOS = 'CANNOT_BE_REIMBURSED_FOR_FUTURE_DOS',
    CLAIM_SUBMITTED_AFTER_DEADLINE = 'CLAIM_SUBMITTED_AFTER_DEADLINE',
    MEDICAL_EXPENSE_NOT_ELIGIBLE = 'MEDICAL_EXPENSE_NOT_ELIGIBLE',
    ADDITIONAL_INFO_NEEDED_FOR_PRIOR_BALANCE_DUE = 'ADDITIONAL_INFO_NEEDED_FOR_PRIOR_BALANCE_DUE',
    AMOUNT_NEEDED = 'AMOUNT_NEEDED',
    DATE_OF_SERVICE_NEEDED = 'DATE_OF_SERVICE_NEEDED',
    DATE_RANGE_OF_CARE_NEEDED = 'DATE_RANGE_OF_CARE_NEEDED',
    DOCUMENT_NEEDS_TO_BE_ENGLISH_AND_USD = 'DOCUMENT_NEEDS_TO_BE_ENGLISH_AND_USD',
    DOCUMENT_NOT_READABLE = 'DOCUMENT_NOT_READABLE',
    HANDWRITTEN_RECEIPT_NOT_SUFFICIENT = 'HANDWRITTEN_RECEIPT_NOT_SUFFICIENT',
    MERCHANT_NEEDED = 'MERCHANT_NEEDED',
    SERVICE_DESCRIPTION_NEEDED = 'SERVICE_DESCRIPTION_NEEDED',
    SERVICE_FOR_NEEDED = 'SERVICE_FOR_NEEDED',
    AUTOMATICALLY_APPROVED_RECURRING_CARD_SWIPE = 'AUTOMATICALLY_APPROVED_RECURRING_CARD_SWIPE',
    CUSTOM = 'CUSTOM',
    AUTOMATICALLY_APPROVED_BY_SIGIS = 'AUTOMATICALLY_APPROVED_BY_SIGIS',
    AUTOMATICALLY_APPROVED_EXCESS_CONTRIBUTION_REQUEST = 'AUTOMATICALLY_APPROVED_EXCESS_CONTRIBUTION_REQUEST',
    APPEAL_NOTE = 'APPEAL_NOTE'
}


/**
 * Check if a given object implements the IClaimApprovalStatusAggregatorDto interface.
 */
export function instanceOfIClaimApprovalStatusAggregatorDto(value: object): value is IClaimApprovalStatusAggregatorDto {
    return true;
}

export function IClaimApprovalStatusAggregatorDtoFromJSON(json: any): IClaimApprovalStatusAggregatorDto {
    return IClaimApprovalStatusAggregatorDtoFromJSONTyped(json, false);
}

export function IClaimApprovalStatusAggregatorDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IClaimApprovalStatusAggregatorDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'claim_id': json['claim_id'] == null ? undefined : json['claim_id'],
        'claim_approval_status_type': json['claim_approval_status_type'] == null ? undefined : json['claim_approval_status_type'],
        'claim_approval_status_code': json['claim_approval_status_code'] == null ? undefined : json['claim_approval_status_code'],
        'claim_approval_status_codes': json['claim_approval_status_codes'] == null ? undefined : json['claim_approval_status_codes'],
        'custom_denial_reason': json['custom_denial_reason'] == null ? undefined : json['custom_denial_reason'],
        'valid_from': json['valid_from'] == null ? undefined : (new Date(json['valid_from'])),
        'valid_to': json['valid_to'] == null ? undefined : (new Date(json['valid_to'])),
        'claim_actor': json['claim_actor'] == null ? undefined : IClaimActorAggregatorDtoFromJSON(json['claim_actor']),
        'approved_amount': json['approved_amount'] == null ? undefined : json['approved_amount'],
        'initially_processed_incorrectly': json['initially_processed_incorrectly'] == null ? undefined : json['initially_processed_incorrectly'],
    };
}

export function IClaimApprovalStatusAggregatorDtoToJSON(json: any): IClaimApprovalStatusAggregatorDto {
    return IClaimApprovalStatusAggregatorDtoToJSONTyped(json, false);
}

export function IClaimApprovalStatusAggregatorDtoToJSONTyped(value?: IClaimApprovalStatusAggregatorDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'claim_id': value['claim_id'],
        'claim_approval_status_type': value['claim_approval_status_type'],
        'claim_approval_status_code': value['claim_approval_status_code'],
        'claim_approval_status_codes': value['claim_approval_status_codes'],
        'custom_denial_reason': value['custom_denial_reason'],
        'valid_from': value['valid_from'] == null ? undefined : ((value['valid_from']).toISOString()),
        'valid_to': value['valid_to'] == null ? undefined : ((value['valid_to']).toISOString()),
        'claim_actor': IClaimActorAggregatorDtoToJSON(value['claim_actor']),
        'approved_amount': value['approved_amount'],
        'initially_processed_incorrectly': value['initially_processed_incorrectly'],
    };
}

